<template>
    <ModalComponent :visible="visible" :title="title" @close="$emit('close')">
        <slot></slot>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/ModalComponent.vue';

export default {
    components: {
        ModalComponent,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
    },
    emits: ['close'],
};
</script>
